<template>
  <v-navigation-drawer
    class="elevation-8 right-navigation-drawer"
    disable-resize-watcher
    :width="rightSidebarWidth"
    right
    stateless
    hide-overlay
    app
    v-model="showInfoMenu"
    color="whitesmoke"
  >
    <v-sheet
      v-if="themeProfile"
      class="mx-auto"
      height="100%"
    >
      <v-btn
        @click="close"
        color="blue"
        absolute
        top
        label="Lukk sidemeny"
        aria-label="Lukk sidemeny"
        right
        style="margin-top: 30px;"
        fab
        small
      >
        <v-icon color="white">close</v-icon>
      </v-btn>
      <div
        v-if="themeProfile && showInfoMenu"
        class="image-container"
      >
        <v-img
          :src="
            themeProfile.hasOwnProperty('largeImageUrl')
              ? themeProfile.largeImageUrl
              : getImgUrl(themeProfile.id)
          "
          :lazy-src="themeProfile.imageUrl"
          class="grey lighten-2"
        >
          <v-layout
            pa-2
            align-end
            column
            fill-height
            class="lightbox white--text"
          >
            <v-spacer></v-spacer>
            <v-flex shrink>
              <div class="caption">
                Foto: {{ themeProfile.imageAttribution }}
              </div>
            </v-flex>
          </v-layout>
        </v-img>
      </div>

      <v-sheet
        class="pb-0 mb-0"
        v-if="themeProfile.zoomLevelDescriptions"
      >
        <v-divider class="mt-0"></v-divider>
        <v-card-text style="padding-bottom: 0px;">
          <layer-zoom-level-description
            style="font-size: 16px; margin-left: 15px; margin-right: 15px;"
            :zoom-level-descriptions="themeProfile.zoomLevelDescriptions"
          />
        </v-card-text>
      </v-sheet>

      <v-sheet>
        <v-card-title style="padding-top: 0px">
          <div v-if="themeProfile">
            <v-subheader
              class="title mt-4 pb-2"
              color="grey"
            >{{
              showHovedforklaring
                ? themeProfile.hovedTemaTitle
                : themeProfile.appTitle
            }}</v-subheader>
            <div :class="{ 'sidebar-box': !showFullDescription }">
              <div
                class="body-1 theme-description"
                style="padding-left: 15px; padding-right: 15px; text-overflow: ellipsis; "
                v-html="
                  this.showHovedforklaring
                    ? this.themeProfile.HovedTemaforklaring
                    : this.themeProfile.Temaforklaring
                    ? this.themeProfile.Temaforklaring
                    : 'Ingen beskrivelse'
                "
              ></div>
              <layer-statistics-table
                v-show="!showHovedforklaring"
                :profile="this.themeProfile"
              />
              <div
                v-show="!showHovedforklaring"
                class="pt-4 pl-3"
                v-html="themeProfile.NVESite"
              ></div>
              <div
                v-show="!showHovedforklaring"
                class="pt-4 pl-3"
                v-if="profileAtlasLink !== ''"
              >
                <a
                  flat
                  :href="profileAtlasLink"
                >Åpne temaet i NVE Atlas</a>
              </div>
            </div>
          </div>
        </v-card-title>
      </v-sheet>

      <v-sheet v-if="themeProfile.links">
        <v-card-title>
          <div v-if="themeProfile">
            <v-subheader
              class="pb-0"
              color="grey"
            >Lenker</v-subheader>
            <v-list-tile
              v-for="(link, index) in themeProfile.links"
              :key="index"
              :href="link.url"
            >
              <v-list-tile-title class="body-1 pl-2 blue--text">{{ link.title }} <v-icon class="body-1">open_in_new</v-icon>
              </v-list-tile-title>
            </v-list-tile>
          </div>
        </v-card-title>
      </v-sheet>
    </v-sheet>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LayerZoomLevelDescription from "@/pages/MapPage/Tools/Layers/LayerZoomLevelDescription";
import LayerStatisticsTable from "@/pages/MapPage/Tools/Layers/LayerStatisticsTable";
export default {
  name: "LayerInfoDrawer",
  components: {
    LayerZoomLevelDescription,
    LayerStatisticsTable
  },
  computed: {
    ...mapState([
      "selectedTheme",
      "favourites",
      "extent",
      "showHovedforklaring"
    ]),
    showInfoMenu: {
      set (showInfoMenu) {
        if (this.showInfoMenu !== showInfoMenu) {
          this.setShowInfoMenu(showInfoMenu);
        }
      },
      get () {
        return this.$store.state.showInfoMenu;
      }
    },
    themeProfile: function () {
      return this.$store.getters["getAddedMapProfile"](this.selectedTheme);
    },
    profileAtlasLink () {
      if (this.themeProfile.hasOwnProperty("SaksbehandlerVerktoy")) {
        let saksbehandlerVerktoyUrl = this.themeProfile.SaksbehandlerVerktoy.match(
          // eslint-disable-next-line no-useless-escape
          /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim
        )[0];

        if (saksbehandlerVerktoyUrl.includes("&extent=")) {
          let extentString =
            "&extent=" +
            this.extent.xmin +
            "," +
            this.extent.ymin +
            "," +
            this.extent.xmax +
            "," +
            this.extent.ymax;
          return saksbehandlerVerktoyUrl.replace("&extent=", extentString);
        } else {
          return saksbehandlerVerktoyUrl;
        }
      } else {
        return "";
      }
    },
    rightSidebarWidth () {
      if (this.$vuetify.breakpoint.xlAndUp) {
        return "440";
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return "420";
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        return "350";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "300";
      } else {
        return "300";
      }
    },
    description: function () {
      if (this.showFullDescription) {
        return this.themeProfile.TemaForklaring;
      } else {
        return this.themeProfile.TemaForklaring;
      }
    }
  },
  props: {
    theme: Object
  },
  data: function () {
    return {
      showme: false,
      showFullDescription: true
    };
  },
  methods: {
    ...mapActions(["addFavourite", "removeFavourite", "setShowInfoMenu"]),
    close () {
      this.setShowInfoMenu(false);
    },
    getImgUrl (id) {
      try {
        return require("../../../../assets/large/" + id + ".jpg");
      } catch (e) {
        require("../../../../assets/large/" + "placeholder" + ".jpg");
      }
    }
  },
  created () { }
};
</script>

<style>
.image-container {
  position: relative;
  text-align: left;
  color: white;
  margin: 0px;
}

.giveMeEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* number of lines to show */
  line-height: 1.5;
  /* fallback */
  max-height: 1 * 3;
  /* fallback */
}

.sidebar-box {
  max-height: 150px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-box .read-more {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  margin: 0;
  padding: 40px 0;

  /* "transparent" only works here because == rgba(0,0,0,0) */
  background-image: linear-gradient(to bottom, transparent, white);
}

.theme-description ul {
  margin-left: 20px;
  list-style-type: circle;
}

.theme-description ul li {
  display: list-item;
}
</style>
